import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.subCategoryImage = {
    css: css`
    border: #c9c9c9 1px solid !important;
    border-radius: 50% !important;
    background: #fff;
    img {
        height: 100%;
        max-width: 100%;
        border-radius: 50% !important;
    }
    `,
};
categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    css: css`
        width: 100%;
    `,
    color: "text.main",
    typographyProps: {
        weight: "bold",
        variant: "h2",
        css: css`
            width: 100%;
            text-align: center;
            word-wrap: break-word;
            font-size: inherit;
            text-transform: none;
            margin-bottom: inherit;
            font-family: inherit;
        `,
    },
};
